import { types } from "./types";

export const getAppVersion = () => ({
  type: types.GET_VERSION,
});
